<template>
  <v-container fluid>
    <v-card class="mt-2">
      <v-card-title>
        <span class="headline mb-0">manual</span>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="results"
        :rows-per-page-items="[-1]"
        item-key="link"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.name }}</td>
          <td>
            <a @click="$watchVideo(props.item.link)" href="#">{{
              props.item.linkName
            }}</a>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      headers: [
        {
          text: 'Page',
          sortable: false,
        },
        {
          text: 'Link',
          sortable: false,
        },
      ],
      results: [
        {
          name: '見積システム',
          link: 'B0200-01',
          linkName: 'マニュアルビデオDL1',
        },
        {
          name: '見積システム',
          link: 'B0200-02',
          linkName: 'マニュアルビデオDL2',
        },
        {
          name: 'INV P/L登録',
          link: 'B0300-01',
          linkName: this.$t('app.buttons.videoTutorial'),
        },
        {
          name: 'Shipping Advice',
          link: 'B0400-01',
          linkName: this.$t('app.buttons.videoTutorial'),
        },
        {
          name: '納入指示',
          link: 'B0600-01',
          linkName: 'マニュアルビデオDL1',
        },
        {
          name: '納入指示',
          link: 'B0600-02',
          linkName: 'マニュアルビデオDL2',
        },
        {
          name: '倉庫別ーおまかせ予約',
          link: 'B2300-01',
          linkName: 'マニュアルビデオDL1',
        },
        {
          name: '倉庫別ーコンテナ調整',
          link: 'B2300-02',
          linkName: 'マニュアルビデオDL2',
        },
        {
          name: '倉庫別ー倉庫表示設定',
          link: 'B2300-03',
          linkName: 'マニュアルビデオDL3',
        },
        {
          name: '倉庫別ー倉庫予約',
          link: 'B2300-04',
          linkName: 'マニュアルビデオDL4',
        },
        {
          name: '倉庫別ー仮予約置換え',
          link: 'B2300-05',
          linkName: 'マニュアルビデオDL5',
        },
        {
          name: '倉庫別ー例外納入指示',
          link: 'B2300-06',
          linkName: 'マニュアルビデオDL6',
        },
        {
          name: '倉庫別-コンテナ枠変更',
          link: 'B2300-07',
          linkName: 'マニュアルビデオDL7',
        },
        {
          name: 'D/O確定',
          link: 'B0800-01',
          linkName: 'マニュアルビデオDL',
        },
        {
          name: 'EIAJ検収伝票発行',
          link: 'B0900-01',
          linkName: 'マニュアルビデオDL',
        },
        {
          name: this.$t('B1300.title'),
          link: 'B1300-01',
          linkName: this.$t('app.buttons.videoTutorial'),
        },
        {
          name: 'BL確認完了送信',
          link: 'B1600-01',
          linkName: this.$t('app.buttons.videoTutorial'),
        },
        {
          name: 'PO変更・取消一覧',
          link: 'B1800-01',
          linkName: 'マニュアルビデオDL1',
        },
        {
          name: 'PO変更・取消一覧',
          link: 'B1800-02',
          linkName: 'マニュアルビデオDL2',
        },
      ],
    }
  },
}
</script>

<style>
</style>